/**
 * Uploads a File directly to S3 using a pre-signed URL.
 * Follows the same pattern as saas-modules/item-inspection's uploadFileToS3
 * but accepts a File object instead of a data URI.
 *
 * @param contentType - Must match the Content-Type used when generating the
 *   presigned URL, otherwise S3 will reject the upload with a 403.
 */
export const uploadToS3 = async (args: {
  presignedUrl: string;
  file: File;
  contentType: string;
}): Promise<void> => {
  const response = await fetch(args.presignedUrl, {
    method: 'PUT',
    body: args.file,
    headers: {
      'Content-Type': args.contentType,
    },
  });

  if (!response.ok) {
    throw new Error(`S3 upload failed with status ${response.status}`);
  }
};
